<template>
  <div>
    <div v-once class="squad-actions">
      <span>{{
        $t(
          '_web_tournament-edit-squad-subtitle',
          'Edit your roster and choose players for your upcoming match'
        )
      }}</span>
    </div>

    <div class=" flex-grow-1 justify-content-between grid-wrapper">
      <div class="roster-column">
        <div class="roster-wrapper">
          <div class="mb-3">
            <div class="d-flex justify-content-between pb-4">
              <span v-once class="roster-title">{{
                $t('_web_tournament_roster', 'Roster')
              }}</span>
              <span class="roster-counter">
                {{ memberRoster.length + '/' + battle.squad + ' Players' }}
              </span>
            </div>
          </div>
          <HeraDummyList
            v-if="isLoading"
            icon-name="dummy/matches"
            :size="210"
            position="center"
            class="flex-grow-1"
          >
            {{
              $t(
                '_web_tournament-create-roster-loading-size',
                'Fetching your current roster...'
              )
            }}
          </HeraDummyList>
          <template v-else>
            <div
              v-for="(member, index) in memberRoster"
              :key="`member-roster-${member.login}`"
              class="d-flex justify-content-between align-items-center cursor-hand rounded"
            >
              <ListItemAccount
                :key="member.login"
                :avatar-props="generateAvatarProps(member)"
                v-bind="{
                  type: member.type,
                  avatar: member.avatar,
                  name: $filters.displayName(member),
                  accountId: member.login,
                  size: 48,
                  approved: member.approved || member.verified,
                  role: !index ? 'Captain' : '',
                }"
                class="d-flex align-items-center w-100 mt-2 roster-item"
              >
              </ListItemAccount>
              <div
                width="36"
                class="memberactionicon"
                @click.stop="removePlayerFromRoster(member)"
              >
                <img alt="removeMember" src="@/assets/images/icons/right.svg" />
              </div>
            </div>

            <div
              v-for="index in membersPlaceholderSize"
              :key="`player-placeholder-${index}`"
              class="create-roster-placeholder"
            >
              <ListItemEmptyPlaceholder
                :text="
                  $t(
                    '_web_tournament-create-roster-participant-placeholder',
                    'Add player from list'
                  )
                "
                :height="20"
                class=""
              />
            </div>
          </template>
        </div>
        <div class="substitutes-wrapper">
          <div class="mb-3">
            <div class="d-flex justify-content-between pb-4">
              <span class="roster-title ">{{
                $t('_web_tournament_substitutes', 'Substitiutes')
              }}</span>
              <span class="roster-counter">
                {{ membersBench.length + '/' + benchSize + ' Players' }}
              </span>
            </div>
          </div>
          <HeraDummyList
            v-if="isLoading"
            icon-name="dummy/matches"
            :size="210"
            position="center"
            class="flex-grow-1"
          >
            {{
              $t(
                '_web_tournament-create-roster-loading-size',
                'Fetching your current roster...'
              )
            }}
          </HeraDummyList>
          <template v-else>
            <div
              v-for="member in membersBench"
              :key="`member-bench-${member.login}`"
              class="d-flex justify-content-between align-items-center"
            >
              <ListItemAccount
                :avatar-props="generateAvatarProps(member)"
                v-bind="{
                  type: member.type,
                  avatar: member.avatar,
                  name: $filters.displayName(member),
                  accountId: member.login,
                  size: 48,
                  approved: member.approved || member.verified,
                }"
                class="d-flex align-items-center w-100 mt-2 roster-item"
              >
              </ListItemAccount>
              <div
                width="36"
                class="memberactionicon"
                @click.stop="addPlayerToRosters(member)"
              >
                <img alt="removeMember" src="@/assets/images/icons/left.svg" />
              </div>
            </div>

            <div
              v-for="index in benchPlaceholderSize - 1"
              :key="`player-placeholder-${index}`"
              class="create-roster-placeholder"
            >
              <ListItemEmptyPlaceholder
                :text="
                  $t(
                    '_web_tournament-create-roster-participant-placeholder',
                    'Add player from list'
                  )
                "
                class=""
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import isLoadingMixin from '@/mixins/isLoading';

import ListItemAccount from '@/components/common/ListItemAccount';
import ListItemEmptyPlaceholder from '@/components/common/ListItemEmptyPlaceholder';

import { translate } from '@/mixins/translate';

export default {
  name: 'BattleSquad',
  components: {
    ListItemAccount,

    ListItemEmptyPlaceholder,
  },
  mixins: [isLoadingMixin, translate('_web_battle-squad-tab')],
  data() {
    return {
      isLoading: false,
      roster: [],
      tournament: [],
      newbattle: [],
      memberRoster: [],
      membersBench: [],
    };
  },

  computed: {
    ...mapGetters({
      battle: 'dynamicBattleModel',
    }),
    ...mapState('my', ['account']),
    // isEmptyList() {
    //   return !this.battle[`squad${this.accountNumber}`].length;
    // },
    membersPlaceholderSize() {
      return this.battle.squad - this.memberRoster.length;
    },
    benchSize() {
      const benchSize =
        this.tournament.max_players - this.tournament.squad_size;
      return Math.max(0, benchSize);
    },
    benchPlaceholderSize() {
      return this.tournament.squad_size;
    },
    // memberRoster() {
    //   return this.newbattle.players[this.accountNumber].squad;
    // },
    // membersBench() {
    //   return this.newbattle.players[this.accountNumber].bench;
    // },
    accountNumber() {
      return this.battle.myIndex || 0;
    },
  },
  async created() {
    this.roster = await this.getTournamentSquadParticipants(
      this.battle.tournament._id
    );
    this.tournament = await this.getTournament(this.battle.tournament._id);
  },
  updated() {
    this.initializeState();
  },
  mounted() {
    this.initializeState();
  },
  methods: {
    ...mapActions([
      'deletePlayerFromRoster',
      'addPlayerToRoster',
      'getConversationInfo',
      'errorNotify',
      'getTournamentSquadParticipants',
      'getTournament',
      'getBattleInfo',
    ]),
    ...mapMutations(['setActivePopoverChat', 'showPopoverChat']),
    openPopoverChat(event, login) {
      if (!event.ctrlKey) {
        this.showPopoverChat();

        this.getConversationInfo({ conversationId: login })
          .then(res => {
            this.setActivePopoverChat(res.id);
          })
          .catch(this.errorNotify);
        event.preventDefault();
      }
    },
    generateAvatarProps({ type, avatar: imgUrl }) {
      return {
        size: 50,
        type,
        imgUrl,
      };
    },

    async initializeState() {
      this.newbattle = await this.getBattleInfo(this.battle._id);
      this.membersBench = this.newbattle.players[this.accountNumber].bench;
      this.memberRoster = this.newbattle.players[this.accountNumber].squad;
    },

    removePlayerFromRoster(player) {
      this.setLoading();
      this.deletePlayerFromRoster({
        battleID: this.battle._id,
        playerID: player.login,
      })
        .then(this.$forceUpdate())
        .finally(this.unsetLoading());
    },
    addPlayerToRosters(player) {
      this.addPlayerToRoster({
        battleID: this.battle._id,
        playerID: player.login,
      }).then(this.$forceUpdate());
    },
  },
};
</script>

<style lang="scss" scoped>
.memberactionicon {
  cursor: pointer;
  .app-rtl & {
    transform: scaleX(-1);
  }
  @media (max-width: 1080px) {
    transform: rotate(90deg);
  }
}
.squad-actions {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 80px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-top: 3rem;
  margin-bottom: 2rem;
  color: $new-fg-neutral-faded;
  border-top: 1px solid $new-bg-neutral;
  border-bottom: 1px solid $new-bg-neutral;
}
.create-roster-placeholder {
  height: 4rem;
  max-width: 16rem !important;
}
.add-member-icon {
  cursor: pointer;
}
.grid-wrapper {
  padding-top: 2rem;
  gap: 2rem;
  justify-content: center;
  display: flex;
}
.roster-header {
  max-width: 1200px;
  width: 100%;
  margin: auto;
}

.create-roster-heading {
  gap: 0.875rem;
  max-width: 60vw;
}
.create-roster-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: $new-fg-neutral-faded;
}
.create-roster-subtitle {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $new-fg-neutral-faded;
  overflow-wrap: break-word;
}
.back-button-create-roster {
  margin-top: -2rem !important;
}
.roster-wrapper,
.substitutes-wrapper,
.member-wrapper {
  background-color: $new-bg-base;
  padding: 2.5rem 4rem;
  border-radius: 5px;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 325px;
  @media (max-width: 600px) {
    padding: 1rem;
    min-width: 250px;
  }
}
.roster-title {
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
}
.roster-counter {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.roster-description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $new-fg-neutral-faded;
}
.roster {
  gap: 3rem;
  &-action {
    height: 3rem;
    padding: 1rem;
    border-radius: 0.5rem;
    width: 10rem;
    align-self: flex-end;
    > span {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }
  &-item {
    border: none;
    height: 4rem;
    max-width: 15rem !important;
    padding: 0.5rem 0rem;
    @media (max-width: 600px) {
      max-width: 10rem !important;
    }
  }
  &-column {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    width: 100%;
    @media (max-width: 1080px) {
      flex-direction: column;
    }
  }
}
</style>
